import { SpecimenResource } from "@skinsoft/types"
import { dbCacheDown } from "../dexie/cache-down"
import { STATS_KEYS } from "../dexie/stats-keys"
import { OfflineDataFetcher } from "@skinsoft/offline"
import { specimenSelectors } from "@skinsoft/selectors"
import { matchesRegex } from "@skinsoft/utils"

// @ts-ignore
export class SpecimenOfflineDataFetcher extends OfflineDataFetcher<SpecimenResource> {
    constructor() {
        super(dbCacheDown.specimen, STATS_KEYS.specimen)
    }

    protected async queryTextFilter(entity: SpecimenResource, queryText: string, locale: string): Promise<boolean> {
        const lowerCaseQueryText: string = queryText.toLowerCase()

        let titleMatch: boolean
        let identifierMatch: boolean

        // Specimen title match 
        const title: string | undefined = specimenSelectors.title(entity as SpecimenResource, locale);
        try {
            titleMatch = title ? matchesRegex(lowerCaseQueryText, title.toLowerCase()) : false;
        } catch(err) {
            titleMatch = false
        }

        // Specimen identifier match
        const identifier: string = specimenSelectors.firstIdentifier(entity as SpecimenResource) ?? ""
        try {
            identifierMatch = identifier ? matchesRegex(lowerCaseQueryText, identifier.toLowerCase()) : false;
        } catch(err) {
            identifierMatch = false
        }

        return titleMatch || identifierMatch
    }
}